@use '@fukuri-admins/ui/layout' as *;

.wrapper {
  position: relative;
  width: fit-content;
}

// Figmaスタイル: 400×233px 固定サイズ
.image {
  display: block;
  width: 400px;
  height: 233px;
  object-fit: contain;
  background-color: background('Secondary');
  border-radius: borderRadius('lg');
}

// 削除ボタン: 右上 32×32px、白背景・ボーダー付き
// Figma: x=358, y=8 → right: 8px, top: 8px
.removeButton {
  position: absolute;
  top: 8px;
  right: 8px;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 32px;
  height: 32px;

  background-color: background('Primary');
  border: 1px solid border('Quaternary');
  border-radius: borderRadius('lg');
  color: text('High');
  cursor: pointer;

  &:hover:not(:disabled) {
    background-color: background('Secondary');
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px border('Focus');
  }
}
